import { useQuery } from "@tanstack/react-query"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import ResponseError from "#/types/responseError"
import { reportErrorMessage } from "#/utils/ErrorReporting"
import { getTalkToCarrotCareNavigationGuidance } from "#/lib/contentful/contentfulClient"
import { EntryWithoutUnresolvableLinks } from "#/utils/ContentTypes"
import { TypePageGuidanceSkeleton } from "#/types/contentful"

const talkToCarrotCareNavigationGuidance = "getTalkToCarrotCareNavigationGuidance"

export function useGetTalkToCarrotCareNavigationGuidance(locale: string) {
  return useQuery<EntryWithoutUnresolvableLinks<TypePageGuidanceSkeleton>, ResponseError>(
    [talkToCarrotCareNavigationGuidance],
    () => getTalkToCarrotCareNavigationGuidance(locale),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: buildCarrotApiRetryPolicy(3),
      onError: (error) => reportErrorMessage(`Failed to fetch the care navigation page guidance with error: ${error}`)
    }
  )
}
